import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EmployeeWiseCheckRollMonthlySummaryReport } from './Pages/listing';

export const EmployeeWiseCheckRollMonthlySummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={EmployeeWiseCheckRollMonthlySummaryReport} />
    </Fragment>
)